exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".short-wrap {\n  width: calc(100% - 60px);\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 7px; }\n\n.edit-tax {\n  transition: color, 250ms;\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  font-size: 1.2em;\n  vertical-align: middle; }\n\n.edit-tax.glyphicon-pencil:hover {\n  cursor: pointer;\n  color: #fb9615; }\n\n.edit-tax.glyphicon-trash:hover {\n  cursor: pointer;\n  color: #d11; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/projects/tax-select/tax-select.component.scss
// module id = ../../../../../angular/app/components/projects/tax-select/tax-select.component.scss
// module chunks = 1